import axios from 'axios'
import { Message } from 'element-ui'
import { logout, getToken } from './auth'

// 创建 axios 实例
const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API ,
    timeout: 10000,
    headers: {
        'Content-Type': 'application/json;charset=UTF-8'
    }
})

// 请求拦截器
service.interceptors.request.use(
    config => {
        // 在发送请求前做些什么
        const token = getToken()
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`
        }
        return config
    },
    error => {
        // 处理请求错误
        console.error('请求错误:', error)
        return Promise.reject(error)
    }
)

// 响应拦截器
service.interceptors.response.use(
    response => {
        // 对响应数据做些什么
        const res = response.data

        // blob 类型响应（文件下载）直接返回
        if (response.config.responseType === 'blob') {
            return res
        }

        // 兼容后端返回格式 { code, msg/data } 或 { code, message/data }
        if (res.code !== 200 && res.code !== 0) {
            // 处理业务错误
            Message({
                message: res.message || res.msg || '操作失败',
                type: 'error',
                duration: 3000
            })

            // 401: 未授权，需要重新登录
            if (res.code === 401) {
                logout()
                window.location.href = '/login'
            }

            return Promise.reject(new Error(res.message || res.msg || 'Error'))
        }
        return res
    },
    error => {
        // 处理响应错误
        console.error('响应错误:', error)

        let errorMessage = '网络异常，请稍后重试'

        if (error.response) {
            const status = error.response.status

            switch (status) {
                case 400:
                    errorMessage = '请求参数错误'
                    break
                case 401:
                    errorMessage = '登录已失效，请重新登录'
                    logout()
                    setTimeout(() => {
                        window.location.href = '/login'
                    }, 1500)
                    break
                case 403:
                    errorMessage = '暂无权限访问'
                    break
                case 404:
                    errorMessage = '请求资源不存在'
                    break
                case 500:
                    errorMessage = '服务器内部错误'
                    break
                default:
                    errorMessage = error.response.data?.message || `请求失败 [${status}]`
            }
        } else if (error.request) {
            errorMessage = '请求超时，请检查网络连接'
        }

        Message({
            message: errorMessage,
            type: 'error',
            duration: 3000
        })

        return Promise.reject(error)
    }
)


export default service